import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import Navbar from "./Navbar";
import routesConfig from "../../config/routes";
import { matchRoutes, renderMatches, useLocation } from "react-router";
import { Suspense, useEffect, useMemo, useState } from "react";
import layoutConfig from "../../config/layout";
import { RootState } from "store";
import { SidebarState } from "store/features/sidebar";
import { AuthState } from "store/features/auth";
import { useSelector } from "react-redux";
import { Box, CircularProgress, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const ROLE_BG: Record<string, string> = {
  PARENT: "#f0f4ff",
  NURSERY_ADMIN: "#f5f2fa",
  ROOM_LEADER: "#f0faf8",
  NURSERY_PRACTITIONER: "#f0faf8",
};

const Layout: React.FC = () => {
  const location = useLocation();
  const theme = useTheme();
  const { i18n } = useTranslation();
  const isRtl = i18n.dir(i18n.language) === "rtl";
  const { role } = useSelector<RootState, AuthState>((store) => store.auth);

  const { folded } = useSelector<RootState, SidebarState>(
    (state) => state.sidebar,
  );

  const matches = useMemo(() => {
    return matchRoutes(routesConfig, location);
  }, [location]);

  const [
    {
      route: { settings },
    },
  ]: any = matches || [{}];

  const [layout, setLayout] = useState(layoutConfig.default);

  useEffect(() => {
    if (settings && settings.layout) {
      setLayout((layout) => ({ ...layout, ...settings.layout }));
    } else {
      setLayout(layoutConfig.default);
    }
  }, [settings]);

  const sidebarWidth = folded ? 56 : 240;

  return (
    <Suspense
      fallback={
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      }
    >
      <div>
        {layout.sidebar && <Sidebar />}

        <Box
          component="main"
          sx={{
            bgcolor: ROLE_BG[role || "PARENT"] || "#f8f9fa",
            height: "100vh",
            overflow: "auto",
            marginLeft: layout.sidebar ? `${sidebarWidth}px` : 0,
            transition: theme.transitions.create(["marginLeft"], {
              duration: theme.transitions.duration.standard,
            }),
            [theme.breakpoints.down("sm")]: {
              marginLeft: 0,
            },
          }}
        >
          {layout.navbar && <Navbar />}
          {layout.toolbar && <Topbar />}
          {renderMatches(matches)}
        </Box>
      </div>
    </Suspense>
  );
};

export default Layout;
